    (function() {
      const wrapper = document.querySelector('.ai-variants-table');
      if (!wrapper) return;

      // Translations
      const i18n = {
        added: AIVT_CONFIG.i18n.added,
        addedPlural: AIVT_CONFIG.i18n.addedPlural
      };

      // EU-stock popover open/close is handled by its own controller near
      // the end of this script (click-to-toggle, fixed-positioned card).

      // ─── Sticky-header workaround: CSS position:sticky on the <th> /
      //     <thead> doesn't engage in this theme because <body> has
      //     overflow-y: auto (the body is the sticky scroll container
      //     but it doesn't itself scroll — window does). Clone the
      //     original thead into a fixed-position element pinned just
      //     below the site header (height computed dynamically so the
      //     clone never overlaps the search bar / logo) and toggle
      //     visibility based on table position.
      (function () {
        if (window.matchMedia && !window.matchMedia('(min-width: 750px)').matches) return;
        const table = wrapper.querySelector('.ai-variants-table__table');
        const thead = wrapper.querySelector('.ai-variants-table__header');
        if (!table || !thead) return;
        // The horizontal-scroll container. Wide-spec tables scroll inside
        // it, so the clone must clip to its VISIBLE width and follow its
        // scrollLeft — otherwise the sticky header paints the full table
        // width into the whitespace and mismatches the scrolled body.
        const scroller = wrapper.querySelector('.ai-variants-table__wrapper') || table.parentElement;

        const siteHeader = document.querySelector('.site-header');
        function stickyTop() {
          // Position clone just below the site header's current bottom.
          // Recomputed on every scroll/resize since the header collapses
          // when scrolled (site-header-sticky--scrolled class), changing
          // its height.
          if (!siteHeader) return 0;
          return Math.max(0, siteHeader.getBoundingClientRect().bottom);
        }

        const clone = document.createElement('div');
        clone.className = 'vt-sticky-clone';
        const cloneTbl = document.createElement('table');
        cloneTbl.className = table.className;
        cloneTbl.appendChild(thead.cloneNode(true));
        clone.appendChild(cloneTbl);
        document.body.appendChild(clone);

        function syncScroll() {
          // Keep the clone's inner table aligned with the horizontally
          // scrolled body. The clone container (overflow:hidden) clips it
          // to the visible width.
          cloneTbl.style.transform = 'translateX(' + (-scroller.scrollLeft) + 'px)';
        }

        function syncWidths() {
          // Align clone columns with the original table cells so labels
          // sit above the right column. Read original header cell widths.
          const origThs = thead.querySelectorAll('th');
          const cloneThs = clone.querySelectorAll('th');
          if (origThs.length !== cloneThs.length) return;
          // Mirror the auto-fit state so the clone's header units wrap the
          // same way the live table's do (keeps the columns aligned).
          clone.classList.toggle('aivt-fit-units', wrapper.classList.contains('aivt-fit-units'));
          // Pin the clone to the VISIBLE scroller box (not the possibly
          // off-screen inner table) and clip to its width; the inner
          // clone table keeps the full table width and is translated to
          // match scrollLeft. When the table fits (no overflow) the two
          // widths are equal and translateX is 0 — identical to before.
          const scRect = scroller.getBoundingClientRect();
          const tableRect = table.getBoundingClientRect();
          clone.style.left = scRect.left + 'px';
          clone.style.width = scRect.width + 'px';
          cloneTbl.style.width = tableRect.width + 'px';
          origThs.forEach((th, i) => {
            const w = th.getBoundingClientRect().width;
            cloneThs[i].style.width = w + 'px';
            cloneThs[i].style.minWidth = w + 'px';
            cloneThs[i].style.maxWidth = w + 'px';
          });
          syncScroll();
        }

        function update() {
          const top = stickyTop();
          clone.style.top = top + 'px';
          const r = table.getBoundingClientRect();
          // Active when table top is above the sticky line AND the
          // table bottom is still below it (so we're inside the table).
          const inside = r.top < top && r.bottom > top + 40;
          if (inside) {
            if (!clone.classList.contains('is-active')) syncWidths();
            clone.classList.add('is-active');
          } else {
            clone.classList.remove('is-active');
          }
        }

        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', () => { syncWidths(); update(); }, { passive: true });
        // Follow the table's own horizontal scroll while the clone is up.
        scroller.addEventListener('scroll', () => {
          if (clone.classList.contains('is-active')) syncScroll();
        }, { passive: true });
        update();
      })();

      // ─── Auto-fit units. Desktop only. When the table is wider than its
      //     scroll wrapper, wrap each spec/option header's unit onto a small
      //     second line (via the .aivt-fit-units class + CSS) to reclaim
      //     width, so the horizontal scrollbar is a last resort rather than
      //     the norm. Measure with the class OFF first (natural width) so
      //     the decision never oscillates; only add it when it's needed. ───
      (function () {
        if (window.matchMedia && !window.matchMedia('(min-width: 750px)').matches) return;
        const scroller = wrapper.querySelector('.ai-variants-table__wrapper');
        const table = wrapper.querySelector('.ai-variants-table__table');
        if (!scroller || !table) return;
        function applyFit() {
          wrapper.classList.remove('aivt-fit-units');       // measure natural width
          if (scroller.scrollWidth - scroller.clientWidth > 1) {
            wrapper.classList.add('aivt-fit-units');          // wrap units to try to fit
          }
        }
        wrapper.__aivtApplyFit = applyFit;                   // let load-more re-check
        applyFit();
        window.addEventListener('resize', applyFit, { passive: true });
        // Re-check once webfonts settle (they change label widths).
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyFit);
      })();

      // ============================================
      // LOAD MORE VARIANTS - Ajax pagination
      // ============================================
      const loadMoreContainer = wrapper.querySelector('.ai-variants-loadmore');
      if (loadMoreContainer) {
        const loadMoreBtn = loadMoreContainer.querySelector('[data-load-more-variants]');
        const loadedCountEl = loadMoreContainer.querySelector('.loaded-count');
        const tableBody = wrapper.querySelector('.ai-variants-table__table tbody');
        
        let currentPage = parseInt(loadMoreContainer.dataset.currentPage) || 1;
        const totalPages = parseInt(loadMoreContainer.dataset.totalPages) || 1;
        const totalItems = parseInt(loadMoreContainer.dataset.totalItems) || 0;
        const pageSize = parseInt(loadMoreContainer.dataset.pageSize) || 50;
        const sectionId = loadMoreContainer.dataset.sectionId;
        
        if (loadMoreBtn && tableBody) {
          loadMoreBtn.addEventListener('click', async function() {
            if (currentPage >= totalPages) return;
            
            const btnText = this.querySelector('.btn-text');
            const btnLoading = this.querySelector('.btn-loading');
            
            // Show loading state
            this.disabled = true;
            btnText.style.display = 'none';
            btnLoading.style.display = 'inline-flex';
            
            try {
              const nextPage = currentPage + 1;
              
              // Use Section Rendering API
              const response = await fetch(`${window.location.pathname}?page=${nextPage}&section_id=${sectionId}`);
              
              if (!response.ok) throw new Error('Network response was not ok');
              
              const html = await response.text();
              
              // Parse the response and extract table rows
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              // capture variant rows for existing per-row processing (unchanged)
              const newRows = doc.querySelectorAll('.ai-variants-table__row');
              // append BOTH captions and rows in document order so section titles survive pagination
              const newNodes = doc.querySelectorAll('.ai-variants-table__row, .ai-variants-table__group-title-row');

              if (newRows.length > 0) {
                // Append new rows (and any group-title caption rows) to the table, in document order, with animation
                newRows.forEach(row => row.classList.add('is-new'));
                newNodes.forEach(n => tableBody.appendChild(n));
                if (wrapper.__aivtApplyFit) wrapper.__aivtApplyFit(); // new rows may change column widths

                // Update current page
                currentPage = nextPage;
                
                // Update loaded count
                const loadedCount = Math.min(currentPage * pageSize, totalItems);
                if (loadedCountEl) {
                  loadedCountEl.textContent = loadedCount;
                }
                
                // Sync Offer mode state for new rows
                const offerToggle = wrapper.querySelector('#offer-mode-toggle');
                if (offerToggle && offerToggle.checked) {
                  newRows.forEach(row => {
                    row.classList.add('offer-mode-active');
                  });
                }
                
                // Re-initialize cart indicators for newly loaded rows.
                fetch(window.Shopify.routes.root + 'cart.js')
                  .then(r => r.json())
                  .then(cartData => updateCartIndicators(cartData))
                  .catch(err => console.log('Could not fetch cart for new rows:', err));
                
                // Hide buttons if all pages loaded
                if (currentPage >= totalPages) {
                  this.classList.add('is-hidden');
                  loadAllBtn?.classList.add('is-hidden');
                }
              }
              
            } catch (error) {
              console.error('Error loading more variants:', error);
            } finally {
              // Reset button state
              this.disabled = false;
              btnText.style.display = 'inline';
              btnLoading.style.display = 'none';
            }
          });
        }

        // LOAD ALL button - loads all remaining pages
        const loadAllBtn = loadMoreContainer.querySelector('[data-load-all-variants]');
        if (loadAllBtn && tableBody) {
          loadAllBtn.addEventListener('click', async function() {
            if (currentPage >= totalPages) return;
            
            const btnText = this.querySelector('.btn-text');
            const btnLoading = this.querySelector('.btn-loading');
            
            // Show loading state
            this.disabled = true;
            loadMoreBtn.disabled = true;
            btnText.style.display = 'none';
            btnLoading.style.display = 'inline-flex';
            
            try {
              // Load all remaining pages sequentially
              while (currentPage < totalPages) {
                const nextPage = currentPage + 1;
                
                const response = await fetch(`${window.location.pathname}?page=${nextPage}&section_id=${sectionId}`);
                
                if (!response.ok) throw new Error('Network response was not ok');
                
                const html = await response.text();
                
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // capture variant rows for existing per-row processing (unchanged)
                const newRows = doc.querySelectorAll('.ai-variants-table__row');
                // append BOTH captions and rows in document order so section titles survive pagination
                const newNodes = doc.querySelectorAll('.ai-variants-table__row, .ai-variants-table__group-title-row');

                if (newRows.length > 0) {
                  newRows.forEach(row => row.classList.add('is-new'));
                  newNodes.forEach(n => tableBody.appendChild(n));
                if (wrapper.__aivtApplyFit) wrapper.__aivtApplyFit(); // new rows may change column widths

                  currentPage = nextPage;
                  
                  // Update loaded count
                  const loadedCount = Math.min(currentPage * pageSize, totalItems);
                  if (loadedCountEl) {
                    loadedCountEl.textContent = loadedCount;
                  }
                  
                  // Sync Offer mode state for new rows
                  const offerToggle = wrapper.querySelector('#offer-mode-toggle');
                  if (offerToggle && offerToggle.checked) {
                    newRows.forEach(row => {
                      row.classList.add('offer-mode-active');
                    });
                  }

                  // Restore wishlist state for new rows
                  wrapper.dispatchEvent(new CustomEvent('wishlist:restore'));
                }
              }

              // Update cart indicators for all rows after batch-load.
              fetch(window.Shopify.routes.root + 'cart.js')
                .then(r => r.json())
                .then(cartData => updateCartIndicators(cartData))
                .catch(err => console.log('Could not fetch cart:', err));
              
              // Hide both buttons
              this.classList.add('is-hidden');
              loadMoreBtn.classList.add('is-hidden');
              
            } catch (error) {
              console.error('Error loading all variants:', error);
            } finally {
              this.disabled = false;
              loadMoreBtn.disabled = false;
              btnText.style.display = 'inline';
              btnLoading.style.display = 'none';
            }
          });
        }

        // ============================================
        // AUTO-LOAD initial pages (e.g. 2 pages × 250 = 500 variants)
        // ============================================
        const initialPages = parseInt(loadMoreContainer.dataset.initialPages) || 1;
        if (initialPages > 1 && currentPage < initialPages && currentPage < totalPages && tableBody) {
          console.log('[VariantsTable] Auto-loading pages 2-' + initialPages + ' of ' + totalPages + ' (page size: ' + pageSize + ')');
          (async () => {
            try {
              while (currentPage < initialPages && currentPage < totalPages) {
                const nextPage = currentPage + 1;
                console.log('[VariantsTable] Auto-loading page ' + nextPage + '...');
                const response = await fetch(`${window.location.pathname}?page=${nextPage}&section_id=${sectionId}`);
                if (!response.ok) {
                  console.error('[VariantsTable] Auto-load page ' + nextPage + ' failed: HTTP ' + response.status);
                  break;
                }
                const html = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // capture variant rows for existing per-row processing (unchanged)
                const newRows = doc.querySelectorAll('.ai-variants-table__row');
                // append BOTH captions and rows in document order so section titles survive pagination
                const newNodes = doc.querySelectorAll('.ai-variants-table__row, .ai-variants-table__group-title-row');
                console.log('[VariantsTable] Page ' + nextPage + ': found ' + newRows.length + ' rows');
                if (newRows.length > 0) {
                  newNodes.forEach(n => tableBody.appendChild(n));
                if (wrapper.__aivtApplyFit) wrapper.__aivtApplyFit(); // new rows may change column widths
                  currentPage = nextPage;
                  const loadedCount = Math.min(currentPage * pageSize, totalItems);
                  if (loadedCountEl) loadedCountEl.textContent = loadedCount;
                  // Sync Offer mode for auto-loaded rows
                  const offerToggle = wrapper.querySelector('#offer-mode-toggle');
                  if (offerToggle && offerToggle.checked) {
                    newRows.forEach(row => row.classList.add('offer-mode-active'));
                  }
                  // Restore wishlist state for auto-loaded rows
                  wrapper.dispatchEvent(new CustomEvent('wishlist:restore'));
                } else {
                  console.warn('[VariantsTable] Page ' + nextPage + ' returned 0 rows, stopping auto-load');
                  break;
                }
              }
              // Update cart indicators for auto-loaded rows.
              try {
                const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
                const cartData = await cartRes.json();
                updateCartIndicators(cartData);
              } catch (e) { console.log('[VariantsTable] Could not fetch cart for auto-loaded rows:', e); }
              console.log('[VariantsTable] Auto-load complete. currentPage=' + currentPage + ', totalPages=' + totalPages);
              // Hide load-more container if all pages auto-loaded
              if (currentPage >= totalPages) {
                loadMoreContainer.style.display = 'none';
              }
            } catch (e) {
              console.error('[VariantsTable] Auto-load error:', e);
            }
          })();
        } else if (currentPage >= totalPages) {
          // All variants fit in initial pages, hide the container
          loadMoreContainer.style.display = 'none';
        }
      }

      // Translation for calibration note
      const calibrationNoteTemplate = AIVT_CONFIG.i18n.calibrationNote;
      console.log('Calibration note template loaded:', calibrationNoteTemplate);

      // No pre-loading needed - we have direct product IDs from metaobject!

      // ============================================
      // Cart State Tracking - Show which variants are in cart
      // ============================================
      // Build a per-variant view of the cart: total qty across lines, and the
      // line index (1-based) of the "primary" line for that variant — the one
      // *without* properties[_related_to_variant], so −/+ in the stepper
      // never targets a calibration or varidio add-on line.
      function buildCartIndex(cartData) {
          const qtyByVariant = {};
          const lineByVariant = {};
          if (cartData && cartData.items) {
              cartData.items.forEach((item, i) => {
                  const vid = String(item.variant_id);
                  qtyByVariant[vid] = (qtyByVariant[vid] || 0) + item.quantity;
                  const isRelated = item.properties && item.properties._related_to_variant;
                  if (!isRelated && !(vid in lineByVariant)) {
                      lineByVariant[vid] = i + 1;
                  }
              });
              // Fallback: if no primary line found, use the first line with this variant.
              cartData.items.forEach((item, i) => {
                  const vid = String(item.variant_id);
                  if (!(vid in lineByVariant)) lineByVariant[vid] = i + 1;
              });
          }
          return { qtyByVariant: qtyByVariant, lineByVariant: lineByVariant };
      }

      function updateCartIndicators(cartData) {
          const idx = buildCartIndex(cartData);
          const controls = wrapper.querySelectorAll('[data-cart-control]');
          // Keep the last cart for the stepper's box-aware (ORG-280) paths.
          wrapper._cart = cartData;
          controls.forEach(ctrl => {
              const vid = ctrl.dataset.variantId;
              const looseQty = idx.qtyByVariant[vid] || 0;
              // Box-mapped pieces count each hidden box-of-10 line as 10;
              // every other variant keeps the old per-variant total.
              const isBoxPiece = !!(window.Box10 && window.Box10.map[vid]);
              const qty = isBoxPiece ? window.Box10.totalQty(vid, cartData) : looseQty;
              // The loose line (may be absent when only boxes are in the cart).
              const line = idx.lineByVariant[vid] || 0;
              ctrl.dataset.state = qty > 0 ? 'in-cart' : 'empty';
              ctrl.dataset.qty = String(qty);
              ctrl.dataset.looseQty = String(looseQty);
              if (line) ctrl.dataset.line = String(line); else delete ctrl.dataset.line;
              ctrl.classList.remove('is-loading');
              const count = ctrl.querySelector('[data-cart-stepper-count]');
              if (count) count.textContent = String(qty);
              const row = ctrl.closest('tr');
              if (row) row.classList.toggle('is-in-cart', qty > 0);
          });
      }

      // Stepper click handler: + on empty → triggers the row's existing form
      // submission (preserves inventory checks + calibration/varidio co-add);
      // + on in-cart → increments via CartDrawer.change() (skips co-add);
      // − on in-cart → decrement / remove via CartDrawer.change().
      wrapper.addEventListener('click', function (e) {
          const stepperBtn = e.target.closest('[data-cart-stepper]');
          if (!stepperBtn) return;
          const ctrl = stepperBtn.closest('[data-cart-control]');
          if (!ctrl) return;
          // ORG-280: while Box10 converts loose pieces into a box (POST +
          // drawer refresh) cart line indices shift, so a click now would send
          // change.js a stale line and could hit another product. Ignore it.
          if (window.Box10 && window.Box10.busy) return;
          const action = stepperBtn.dataset.cartStepper;
          const state = ctrl.dataset.state || 'empty';
          const looseQty = parseInt(ctrl.dataset.looseQty || '0', 10);
          const line = parseInt(ctrl.dataset.line || '0', 10);

          if (action === 'plus' && state === 'empty') {
              // First add — go through the form submit path (handles
              // inventory confirm modal + calibration/varidio co-add).
              const form = ctrl.closest('form');
              if (form) {
                  ctrl.classList.add('is-loading');
                  if (typeof form.requestSubmit === 'function') {
                      form.requestSubmit();
                  } else {
                      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                  }
              }
              return;
          }
          // ORG-280 box-mapped pieces: − takes a loose piece, or breaks a box
          // into 9 loose; + with only boxes in the cart adds one loose piece
          // (Box10.normalize turns every 10th loose piece into a box).
          if (window.Box10 && window.Box10.map[ctrl.dataset.variantId] && wrapper._cart) {
              const done = () => ctrl.classList.remove('is-loading');
              if (action === 'minus' && state === 'in-cart') {
                  ctrl.classList.add('is-loading');
                  window.Box10.minusOne(ctrl.dataset.variantId, wrapper._cart).finally(done);
                  return;
              }
              if (action === 'plus' && state === 'in-cart' && !line) {
                  ctrl.classList.add('is-loading');
                  fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ items: [{ id: Number(ctrl.dataset.variantId), quantity: 1 }] })
                  }).then(() => window.CartDrawer && window.CartDrawer.refresh())
                    .catch(err => console.error('[VariantsTable] box10 add failed', err))
                    .finally(done);
                  return;
              }
          }
          // Loose-line quantity (not the box-inclusive total) drives change.js.
          if (action === 'plus' && state === 'in-cart' && line) {
              ctrl.classList.add('is-loading');
              if (window.CartDrawer) window.CartDrawer.change(line, looseQty + 1);
              return;
          }
          if (action === 'minus' && state === 'in-cart' && line) {
              ctrl.classList.add('is-loading');
              if (window.CartDrawer) window.CartDrawer.change(line, Math.max(0, looseQty - 1));
              return;
          }
      });

      // CartDrawer dispatches cart:updated after every successful mutation;
      // we re-read the new cart and re-render each control's state. This is
      // the single source of truth for the row stepper's visual state.
      document.addEventListener('cart:updated', function (e) {
          const cart = e.detail && e.detail.cart;
          if (cart) updateCartIndicators(cart);
          // cart:updated fires mid-conversion too — keep the spinner up.
          if (window.Box10 && window.Box10.busy) setSteppersLoading(true);
      });
      // ORG-280 box conversion in flight: show every stepper as loading (the
      // click handler ignores them meanwhile); box10:idle restores them.
      function setSteppersLoading(on) {
          wrapper.querySelectorAll('[data-cart-control]').forEach(ctrl => ctrl.classList.toggle('is-loading', on));
      }
      document.addEventListener('box10:busy', function () { setSteppersLoading(true); });
      // The piece→box map loads lazily (ORG-286): recount boxes once it lands.
      document.addEventListener('box10:ready', function () {
          if (wrapper._cart) updateCartIndicators(wrapper._cart);
      });
      document.addEventListener('box10:idle', function () {
          if (wrapper._cart) updateCartIndicators(wrapper._cart); else setSteppersLoading(false);
      });

      // Fetch cart on page load
      fetch(window.Shopify.routes.root + 'cart.js')
          .then(r => r.json())
          .then(cartData => {
              updateCartIndicators(cartData);
          })
          .catch(err => console.log('Could not fetch cart:', err));

      // Listen for cart updates from other parts of the page
      document.addEventListener('cart:refresh', function() {
          fetch(window.Shopify.routes.root + 'cart.js')
              .then(r => r.json())
              .then(cartData => {
                  updateCartIndicators(cartData);
              });
      });

      // ============================================
      // Mobile sticky cart summary bar (Claude Design ProductPageMobile).
      // The steppers add straight to the cart (morphing stepper flow), so
      // the bar is a live recap of THIS product's cart lines — count + net
      // total — with a button that opens the cart drawer. The design's
      // batch-add flow is a separate desktop commission.
      // ============================================
      const vtBarMq = window.matchMedia('(max-width: 749px)');
      const vtBarI18n = {
          itemSingular: AIVT_CONFIG.i18n.barItemSingular || 'τεμάχιο',
          itemPlural: AIVT_CONFIG.i18n.barItemPlural || 'τεμάχια',
          // ORG-528: «χωρίς ΦΠΑ» in Greece, «με ΦΠΑ» / «χωρίς φόρους» for a market whose
          // prices are already final (Liquid picks it from vat_mode).
          exclVat: AIVT_CONFIG.i18n.barVatLabel || AIVT_CONFIG.i18n.barExclVat || 'χωρίς ΦΠΑ',
          viewCart: AIVT_CONFIG.i18n.barViewCart || 'Προβολή καλαθιού'
      };
      let vtCartBar = null;
      function vtMoney(cents) {
          return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
      function ensureCartBar() {
          if (vtCartBar) return vtCartBar;
          vtCartBar = document.createElement('div');
          vtCartBar.className = 'vt-cartbar';
          const meta = document.createElement('div');
          meta.className = 'vt-cartbar__meta';
          const count = document.createElement('span');
          count.className = 'vt-cartbar__count';
          count.setAttribute('data-vt-bar-count', '');
          const total = document.createElement('strong');
          total.className = 'vt-cartbar__total';
          const totalNum = document.createElement('span');
          totalNum.setAttribute('data-vt-bar-total', '');
          const vat = document.createElement('span');
          vat.className = 'vt-cartbar__vat';
          vat.textContent = ' ' + vtBarI18n.exclVat;
          total.appendChild(totalNum);
          total.appendChild(vat);
          meta.appendChild(count);
          meta.appendChild(total);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vt-cartbar__btn';
          btn.textContent = vtBarI18n.viewCart;
          btn.addEventListener('click', function () {
              if (window.CartDrawer && window.CartDrawer.open) window.CartDrawer.open();
          });
          vtCartBar.appendChild(meta);
          vtCartBar.appendChild(btn);
          document.body.appendChild(vtCartBar);
          return vtCartBar;
      }
      function updateStickyCartBar(cartData) {
          if (!vtBarMq.matches) {
              if (vtCartBar) {
                  vtCartBar.classList.remove('is-on');
                  document.body.classList.remove('vt-has-cartbar');
              }
              return;
          }
          const vids = new Set(
              Array.from(wrapper.querySelectorAll('[data-cart-control]')).map(c => c.dataset.variantId)
          );
          let count = 0;
          let totalCents = 0;
          ((cartData && cartData.items) || []).forEach(item => {
              const vid = String(item.variant_id);
              const rel = item.properties && item.properties._related_to_variant;
              if (rel && vids.has(String(rel))) {
                  // calibration / varidio co-add line: counts toward the total
                  totalCents += item.final_line_price;
              } else if (!rel && vids.has(vid)) {
                  count += item.quantity;
                  totalCents += item.final_line_price;
              } else if (!rel && window.Box10 && window.Box10.isBox(vid) &&
                         vids.has(String(window.Box10.pieceFor(vid)))) {
                  // ORG-280: a box-of-10 line (separate hidden product) of one
                  // of THIS table's pieces — 10 pieces per box, full line price.
                  count += 10 * item.quantity;
                  totalCents += item.final_line_price;
              }
          });
          const bar = ensureCartBar();
          const on = count > 0;
          bar.classList.toggle('is-on', on);
          document.body.classList.toggle('vt-has-cartbar', on);
          if (on) {
              bar.querySelector('[data-vt-bar-count]').textContent =
                  count + ' ' + (count === 1 ? vtBarI18n.itemSingular : vtBarI18n.itemPlural);
              bar.querySelector('[data-vt-bar-total]').textContent = vtMoney(totalCents);
          }
      }
      // Recompute alongside the row indicators on every cart change.
      const vtOrigUpdateCartIndicators = updateCartIndicators;
      updateCartIndicators = function (cartData) {
          vtOrigUpdateCartIndicators(cartData);
          updateStickyCartBar(cartData);
      };

      // ============================================
      // Mobile: the dimension sketch (custom.sketch, rendered under the
      // gallery in snippets/product.liquid) moves to sit right above the
      // variants table, under its section heading — design ProductPageYgMobile
      // pairs the sketch with the list it explains.
      // ============================================
      if (vtBarMq.matches) {
          const vtSketch = document.querySelector('.product-sketch-image--under-gallery');
          if (vtSketch && wrapper.parentNode) {
              wrapper.parentNode.insertBefore(vtSketch, wrapper);
              vtSketch.classList.add('product-sketch-image--above-table');
          }
      }

      // ============================================
      // Mobile range chips + show-all (design ProductPageYgMobile) — for
      // long variant lists (cutting tools etc). Buckets the FIRST product
      // option's numeric values into 3 contiguous ranges with roughly equal
      // row counts; a show-all button collapses lists past 10 rows.
      // Skipped when grade-grouping renders its own block headers.
      // ============================================
      (function initMobileRangeTools() {
          if (!vtBarMq.matches) return;
          const table = wrapper.querySelector('.ai-variants-table__table');
          if (!table) return;
          if (table.querySelector('.ai-variants-table__group-title-row')) return;
          const PAGE = 10;
          const CHIPS_MIN_ROWS = 13;
          const state = { range: null, expanded: false };
          let chipRow = null;
          let showBtn = null;

          function allRows() {
              return Array.from(table.querySelectorAll('tbody .ai-variants-table__row'));
          }
          function rowValue(row) {
              const c = row.querySelector('.ai-variants-table__option-col:not(.ai-variants-table__xtra-col) .ai-variants-table__option');
              if (!c) return NaN;
              return parseFloat(c.textContent.trim().replace(',', '.'));
          }
          function fmt(n) {
              return String(n).replace('.', ',');
          }

          function buildBuckets(rows) {
              const vals = rows.map(rowValue);
              const numeric = vals.filter(v => !isNaN(v));
              if (numeric.length < rows.length * 0.8) return null;
              const distinct = Array.from(new Set(numeric)).sort((a, b) => a - b);
              if (distinct.length < 6) return null;
              const countByVal = {};
              numeric.forEach(v => { countByVal[v] = (countByVal[v] || 0) + 1; });
              const target = numeric.length / 3;
              const buckets = [];
              let cur = { from: distinct[0], to: distinct[0], n: 0 };
              distinct.forEach(v => {
                  if (buckets.length < 2 && cur.n >= target) {
                      buckets.push(cur);
                      cur = { from: v, to: v, n: 0 };
                  }
                  cur.to = v;
                  cur.n += countByVal[v];
              });
              buckets.push(cur);
              return buckets.filter(b => b.n > 0);
          }

          function applyFilter() {
              const rows = allRows();
              let visible = [];
              rows.forEach(row => {
                  const v = rowValue(row);
                  const inRange = !state.range || (!isNaN(v) && v >= state.range.from && v <= state.range.to);
                  row.classList.toggle('vt-row-hidden', !inRange);
                  if (inRange) visible.push(row);
              });
              visible.forEach((row, i) => {
                  row.classList.toggle('vt-row-overflow', !state.expanded && i >= PAGE);
              });
              if (showBtn) {
                  const overflow = visible.length > PAGE;
                  showBtn.style.display = overflow ? '' : 'none';
                  showBtn.textContent = state.expanded
                      ? (AIVT_CONFIG.i18n.showLess || 'Εμφάνιση λιγότερων')
                      : (AIVT_CONFIG.i18n.showAll || 'Εμφάνιση όλων (__COUNT__)').replace('__COUNT__', visible.length);
              }
          }

          function chip(label, range) {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'vt-chip';
              b.textContent = label;
              b.addEventListener('click', function () {
                  state.range = range;
                  state.expanded = false;
                  chipRow.querySelectorAll('.vt-chip').forEach(c => c.classList.toggle('is-on', c === b));
                  applyFilter();
              });
              return b;
          }

          function setup() {
              const rows = allRows();
              if (rows.length <= PAGE) return;
              // show-all collapse always applies to long lists
              if (!showBtn) {
                  showBtn = document.createElement('button');
                  showBtn.type = 'button';
                  showBtn.className = 'vt-showall';
                  showBtn.addEventListener('click', function () {
                      state.expanded = !state.expanded;
                      applyFilter();
                      if (!state.expanded) {
                          const target = wrapper.getBoundingClientRect().top + window.pageYOffset - 90;
                          window.scrollTo({ top: target, behavior: 'smooth' });
                      }
                  });
                  wrapper.appendChild(showBtn);
              }
              if (!chipRow && rows.length >= CHIPS_MIN_ROWS) {
                  const buckets = buildBuckets(rows);
                  if (buckets && buckets.length > 1) {
                      chipRow = document.createElement('div');
                      chipRow.className = 'vt-chip-row';
                      const all = chip((AIVT_CONFIG.i18n.chipsAll || 'Όλες') + ' (' + rows.length + ')', null);
                      all.classList.add('is-on');
                      chipRow.appendChild(all);
                      buckets.forEach(b => {
                          chipRow.appendChild(chip(
                              b.from === b.to ? fmt(b.from) : fmt(b.from) + '–' + fmt(b.to),
                              b
                          ));
                      });
                      const tblWrapper = wrapper.querySelector('.ai-variants-table__wrapper');
                      wrapper.insertBefore(chipRow, tblWrapper);
                  }
              }
              applyFilter();
          }

          setup();
          // Load-more appends rows asynchronously — rebuild counts/filters.
          const tbody = table.querySelector('tbody');
          if (tbody && wrapper.querySelector('.ai-variants-loadmore')) {
              let t = null;
              new MutationObserver(function () {
                  if (t) clearTimeout(t);
                  t = setTimeout(function () {
                      if (chipRow) { chipRow.remove(); chipRow = null; state.range = null; }
                      setup();
                  }, 300);
              }).observe(tbody, { childList: true });
          }
      })();

      // Offer Mode Toggle Logic (both desktop and mobile)
      const offerToggle = wrapper.querySelector('#offer-mode-toggle');
      const mobileOfferToggle = wrapper.querySelector('.mobile-offer-toggle');

      function handleOfferToggle(isChecked) {
          // Find all forms in the table
          const forms = wrapper.querySelectorAll('.ai-variants-table__form');

          forms.forEach(form => {
              let input = form.querySelector('input[name="properties[Είδος]"]');

              if (isChecked) {
                  if (!input) {
                      input = document.createElement('input');
                      input.type = 'hidden';
                      input.name = 'properties[Είδος]';
                      form.appendChild(input);
                  }
                  input.value = 'Ζήτηση Προσφοράς';
              } else {
                  if (input) input.remove();
              }
          });
          // Sync both toggles
          if (offerToggle) offerToggle.checked = isChecked;
          if (mobileOfferToggle) mobileOfferToggle.checked = isChecked;
      }

      if (offerToggle) {
          offerToggle.addEventListener('change', function() {
              handleOfferToggle(this.checked);
          });
      }
      if (mobileOfferToggle) {
          mobileOfferToggle.addEventListener('change', function() {
              handleOfferToggle(this.checked);
          });
      }

      // Quantity-selector visual feedback (was for the always-visible qty
      // input that the morphing stepper replaced) — removed with the Wolt
      // ATC redesign; backorder messaging now lives only in the stock-confirm
      // modal triggered when qty exceeds inventory at +1 add time.

      // Late-companion co-add. When the user picks a companion (cert or
      // baridio) AFTER the parent tape is already in the cart, the
      // stepper "+" branch is the in-cart qty-bump path — it never
      // re-runs the form-submit co-add logic. So the drawer confirm
      // itself has to add the companion. This helper is called from
      // both drawer confirm handlers. Idempotent: if the same companion
      // variant is already linked to the parent in the cart, it's a
      // no-op (Shopify would otherwise add a duplicate line). If a
      // DIFFERENT companion of the same kind is already linked
      // (user picked a new cert/baridio to replace the old one), we
      // remove the old one first so the cart ends up with the user's
      // current selection only.
      // Returns a Promise<boolean> — true if anything was added.
      async function coAddCompanionIfParentInCart(parentVariantId, kind, selection) {
          if (!parentVariantId || !kind || !selection) return false;
          let cart;
          try { cart = await fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()); }
          catch (e) { return false; }

          const parentLine = cart.items.find(it => String(it.variant_id) === String(parentVariantId));
          if (!parentLine) return false; // parent not in cart — defer to + click

          // Find existing companion of the same kind already linked to this parent.
          const existing = cart.items.find(it => {
              const p = it.properties || {};
              if (String(p._related_to_variant) !== String(parentVariantId)) return false;
              // _companion_kind tag was added 2026-05-29 — legacy items
              // without it are diakrivosi (cert was the only kind back then).
              const itKind = p._companion_kind || 'diakrivosi';
              return itKind === kind;
          });

          if (existing && String(existing.variant_id) === String(selection.variantId)) {
              return false; // already correct — nothing to do
          }

          const tasks = [];
          if (existing) {
              // Remove the stale companion first.
              tasks.push(
                  fetch(window.Shopify.routes.root + 'cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                      body: JSON.stringify({ id: existing.key, quantity: 0 })
                  }).catch(err => console.error('[VariantsTable] stale companion remove failed:', err))
              );
          }

          // Add the new companion. Match the parent's quantity so
          // qty=3 tapes get 3 baridia (consistent with the original
          // bubble-phase co-add behaviour).
          const companionFormData = new FormData();
          companionFormData.append('id', selection.variantId);
          companionFormData.append('quantity', parentLine.quantity);
          companionFormData.append('properties[_related_to_variant]', String(parentVariantId));
          companionFormData.append('properties[_companion_kind]', kind);
          // Preserve the note the form-submit path attaches. It names the
          // INSTRUMENT being calibrated (the parent line), not the certificate.
          if (kind === 'diakrivosi' && parentLine.sku && calibrationNoteTemplate) {
              companionFormData.append('properties[Σημείωση]', calibrationNoteTemplate.replace('__SKU__', parentLine.sku));
          }
          tasks.push(
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
                  body: companionFormData
              }).catch(err => console.error('[VariantsTable] late companion co-add failed:', err))
          );

          await Promise.all(tasks);
          if (window.CartDrawer) {
              await window.CartDrawer.refresh();
              if (window.CartDrawer.open) window.CartDrawer.open();
          } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
          return true;
      }

      // Stock Confirmation Modal Functions
      const stockConfirmModal = document.getElementById('stock-confirm-modal');
      const stockConfirmMessage = document.getElementById('stockConfirmMessage');
      let confirmResolve = null;

      function showStockConfirmModal(message) {
        return new Promise((resolve) => {
          if (!stockConfirmModal || !stockConfirmMessage) {
            resolve(false);
            return;
          }

          stockConfirmMessage.innerHTML = message;
          stockConfirmModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          
          confirmResolve = resolve;
          
          // Focus the confirm button
          const confirmBtn = stockConfirmModal.querySelector('[data-stock-confirm-yes]');
          if (confirmBtn) confirmBtn.focus();
        });
      }

      function hideStockConfirmModal(confirmed) {
        if (!stockConfirmModal) return;
        stockConfirmModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        
        if (confirmResolve) {
          confirmResolve(confirmed);
          confirmResolve = null;
        }
      }

      // Modal event listeners
      stockConfirmModal?.addEventListener('click', function(e) {
        if (e.target.hasAttribute('data-stock-confirm-cancel') || e.target.closest('[data-stock-confirm-cancel]')) {
          hideStockConfirmModal(false);
        }
        if (e.target.hasAttribute('data-stock-confirm-yes') || e.target.closest('[data-stock-confirm-yes]')) {
          hideStockConfirmModal(true);
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && stockConfirmModal && stockConfirmModal.getAttribute('aria-hidden') === 'false') {
          hideStockConfirmModal(false);
        }
      });

      wrapper.addEventListener('submit', async function(e) {
        if (!e.target.classList.contains('ai-variants-table__form')) return;
        e.preventDefault();

        const form = e.target;
        // The morphing stepper has no type="submit" — use the + button as
        // the visual focus for the loading state (used to be the wide cart btn).
        const btn = form.querySelector('[data-cart-stepper="plus"]');
        const cartControl = form.querySelector('[data-cart-control]');
        const qtyInput = form.querySelector('input[name="quantity"]');
        const qty = parseInt(qtyInput.value, 10);

        // New: Inventory Check Logic
        const inventoryPolicy = form.dataset.inventoryPolicy;
        const inventoryQuantity = parseInt(form.dataset.inventoryQuantity, 10);
        const leadTimeMessage = form.dataset.leadTimeMessage;

        console.log('Stock Check:', {
            policy: inventoryPolicy,
            stock: inventoryQuantity,
            qty: qty,
            msg: leadTimeMessage,
            leadTime: AIVT_CONFIG.variantLeadTime
        });

        // If we are tracking stock, allow continue, and user requests more than we have
        if (inventoryPolicy === 'continue' && qty > inventoryQuantity) {
           console.log('Triggering confirmation detected');
           // Calculate how many are backordered
           const availableNow = Math.max(0, inventoryQuantity);
           const backordered = qty - availableNow;

           // Grammar helpers for singular/plural
           const qtyText = qty === 1 ? '1 τεμάχιο' : qty + ' τεμάχια';
           const availableText = availableNow === 1 ? 'Το <span class="highlight">1</span> είναι άμεσα διαθέσιμο' : 'Τα <span class="highlight">' + availableNow + '</span> είναι άμεσα διαθέσιμα';
           const backorderedText = backordered === 1 ? 'το υπόλοιπο <span class="highlight">1</span> τεμάχιο' : 'τα υπόλοιπα <span class="highlight">' + backordered + '</span> τεμάχια';

           let confirmHtml = '';

           // ORG-67: long rulers ship direct from the German factory. Stock ships
           // from us; only the pieces we don't hold come from the factory, with
           // shipping quoted separately. Say exactly that, split by source.
           if (form.dataset.factoryDirect === '1') {
               const fromUs = availableNow > 0
                   ? '<p class="fd-split fd-split--us"><strong>' + availableNow + ' τεμ.</strong> από το στοκ μας<br><span>Αποστολή από εμάς</span></p>'
                   : '';
               confirmHtml = '<p>Έχετε επιλέξει <span class="highlight">' + qtyText + '</span>.</p>' + fromUs +
                   '<p class="fd-split fd-split--de"><strong>' + backordered + ' τεμ.</strong> απευθείας από το εργοστάσιο στη Γερμανία, στην έδρα σας<br>' +
                   '<span>Τα μεταφορικά κοστολογούνται χωριστά — θα σας στείλουμε προσφορά.</span></p>';
           } else if (leadTimeMessage) {
               // Format the lead-time message (split by | for two lines)
               let formattedMessage = leadTimeMessage;
               if (leadTimeMessage.includes('|')) {
                   const parts = leadTimeMessage.split('|');
                   formattedMessage = '<span class="barcode-title">' + parts[0] + '</span><br><span class="barcode-detail">' + parts[1] + '</span>';
               }

               if (availableNow > 0) {
                   confirmHtml = '<p>Έχετε επιλέξει <span class="highlight">' + qtyText + '</span>.</p>' +
                                '<p>' + availableText + '.</p>' +
                                '<p>Για ' + backorderedText + ' ισχύει:</p>' +
                                '<p class="barcode-message">' + formattedMessage + '</p>';
               } else {
                   confirmHtml = '<p>Έχετε επιλέξει <span class="highlight">' + qtyText + '</span>.</p>' +
                                '<p>Δεν υπάρχει άμεση διαθεσιμότητα.</p>' +
                                '<p>Για την παραγγελία σας ισχύει:</p>' +
                                '<p class="barcode-message">' + formattedMessage + '</p>';
               }
           } else {
               // No lead-time message - generic stock notification
               if (availableNow > 0) {
                   confirmHtml = '<p>Έχετε επιλέξει <span class="highlight">' + qtyText + '</span>.</p>' +
                                '<p>' + availableText + '.</p>' +
                                '<p>Για ' + backorderedText + ' θα σας ενημερώσουμε για τον χρόνο παράδοσης.</p>' +
                                '<p class="barcode-message"><span class="barcode-title">Επικοινωνήστε μαζί μας</span><br><span class="barcode-detail">για ακριβή εκτίμηση χρόνου παράδοσης.</span></p>';
               } else {
                   confirmHtml = '<p>Έχετε επιλέξει <span class="highlight">' + qtyText + '</span>.</p>' +
                                '<p>Δεν υπάρχει άμεση διαθεσιμότητα.</p>' +
                                '<p>Θα σας ενημερώσουμε για τον χρόνο παράδοσης.</p>' +
                                '<p class="barcode-message"><span class="barcode-title">Επικοινωνήστε μαζί μας</span><br><span class="barcode-detail">για ακριβή εκτίμηση χρόνου παράδοσης.</span></p>';
               }
           }

           const confirmed = await showStockConfirmModal(confirmHtml);
           if (!confirmed) {
               return; // Stop submission
           }
        }

        if (btn) btn.disabled = true;
        if (cartControl) cartControl.classList.add('is-loading');

        const formData = new FormData(form);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            if (data.status) {
              console.error('[VariantsTable] cart/add failed:', data.description);
              if (btn) btn.disabled = false;
              if (cartControl) cartControl.classList.remove('is-loading');
              return;
            }

            // ─── Calibration co-add ────────────────────────────────────────
            const variantRow = form.closest('tr');
            const rowVarId = variantRow?.dataset.variantId;
            const diakrivosiSelection = (typeof diakrivosiSelections !== 'undefined' && rowVarId) ? diakrivosiSelections.get(rowVarId) : null;
            const hasCalibration = !!diakrivosiSelection;
            const calibrationId = hasCalibration ? diakrivosiSelection.variantId : null;
            // The note names the INSTRUMENT (this row's SKU), not the certificate
            // (diakrivosiSelection.sku): «Διακρίβωση για SKU: JBO-512424».
            const variantSku = hasCalibration ? (variantRow?.dataset.sku || '') : '';
            const coAddTasks = [];

            if (hasCalibration && calibrationId) {
                const calibrationFormData = new FormData();
                calibrationFormData.append('id', calibrationId);
                calibrationFormData.append('quantity', qty);
                calibrationFormData.append('properties[_related_to_variant]', form.querySelector('input[name="id"]').value);
                // Disambiguates this companion line for the cart drawer
                // eyebrow (cert vs baridio share _related_to_variant).
                calibrationFormData.append('properties[_companion_kind]', 'diakrivosi');
                const offerInput = form.querySelector('input[name="properties[Είδος]"]');
                if (offerInput && offerInput.value === 'Ζήτηση Προσφοράς') {
                    calibrationFormData.append('properties[Είδος]', 'Ζήτηση Προσφοράς');
                }
                if (variantSku && calibrationNoteTemplate) {
                    calibrationFormData.append('properties[Σημείωση]', calibrationNoteTemplate.replace('__SKU__', variantSku));
                }
                coAddTasks.push(
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
                        body: calibrationFormData
                    }).catch(err => console.error('[VariantsTable] calibration co-add failed:', err))
                );
            }

            // ─── Varidio co-add ────────────────────────────────────────────
            if (form.dataset.varidioVariantId) {
                const varidioFormData = new FormData();
                varidioFormData.append('id', form.dataset.varidioVariantId);
                varidioFormData.append('quantity', qty);
                varidioFormData.append('properties[_related_to_variant]', form.querySelector('input[name="id"]').value);
                varidioFormData.append('properties[_companion_kind]', 'varidio');
                const offerInputV = form.querySelector('input[name="properties[Είδος]"]');
                if (offerInputV && offerInputV.value === 'Ζήτηση Προσφοράς') {
                    varidioFormData.append('properties[Είδος]', 'Ζήτηση Προσφοράς');
                }
                coAddTasks.push(
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
                        body: varidioFormData
                    }).catch(err => console.error('[VariantsTable] varidio co-add failed:', err))
                );
            }

            // Once all co-adds resolve, ask CartDrawer to refetch /cart.js.
            // CartDrawer dispatches cart:updated which our listener above
            // (line ~3470) uses to morph the stepper to [− 1 +].
            Promise.all(coAddTasks).finally(() => {
                if (btn) btn.disabled = false;
                if (window.CartDrawer) {
                    window.CartDrawer.refresh().then(function () {
                        if (window.CartDrawer.open) window.CartDrawer.open();
                    });
                } else {
                    // Fallback: legacy event-based refresh (Empire listeners).
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                }
                // Also dispatch product-form:submit:success for any other
                // listeners (theme legacy code, third-party trackers).
                document.dispatchEvent(new CustomEvent('product-form:submit:success', { bubbles: true, detail: { form: form } }));
            });
          })
          .catch(error => {
            console.error('[VariantsTable] cart/add error:', error);
            if (btn) btn.disabled = false;
            if (cartControl) cartControl.classList.remove('is-loading');
          });
      });


      // ============================================
      // DIAKRIVOSEIS (Calibration) Modal Logic
      // ============================================
      const hasMultiDiakrivosi = AIVT_CONFIG.hasDiakrivosi;
      const diakrivosiSelections = new Map();

      if (hasMultiDiakrivosi) {
        const diakrivosiModalOverlay = document.getElementById('diakrivosi-modal-overlay');
        const diakrivosiModalList = document.getElementById('diakrivosi-modal-list');
        const diakrivosiModalConfirm = document.getElementById('diakrivosi-modal-confirm');
        const diakrivosiModalClose = diakrivosiModalOverlay?.querySelector('.diakrivosi-modal__close');
        let activeDiakrivosiVariantId = null;

        // Update the footer preview ticker + button label whenever
        // the user picks (or unpicks) a calibration. Reads the
        // currently checked radio out of the list and reflects its
        // title/price into the sticky footer band.
        function updateDiakrivosiFooterPreview() {
            const drawer = document.getElementById('diakrivosi-drawer');
            if (!drawer) return;
            const preview = drawer.querySelector('[data-diakrivosi-preview]');
            const btn = drawer.querySelector('#diakrivosi-modal-confirm');
            const emptyState = drawer.querySelector('[data-confirm-empty]');
            const readyState = drawer.querySelector('[data-confirm-ready]');
            const body = drawer.querySelector('.diakrivosi-drawer__body');
            const checked = diakrivosiModalList && diakrivosiModalList.querySelector('input[type="radio"]:checked');

            if (checked) {
                if (btn) btn.disabled = false;
                if (emptyState) emptyState.hidden = true;
                if (readyState) readyState.hidden = false;
                // Hides the "tap a card" hint banner once a card is picked.
                if (body) body.dataset.hasSelection = 'true';
                if (preview) {
                    preview.hidden = false;
                    const titleEl = preview.querySelector('[data-diakrivosi-preview-title]');
                    const priceEl = preview.querySelector('[data-diakrivosi-preview-price]');
                    if (titleEl) titleEl.textContent = checked.dataset.productTitle || '';
                    if (priceEl) {
                        const raw = parseFloat(checked.dataset.productPriceRaw || '0');
                        priceEl.textContent = raw > 0 ? '+ ' + (checked.dataset.productPrice || '') : (checked.dataset.productPrice || '');
                    }
                }
            } else {
                if (btn) btn.disabled = true;
                if (emptyState) emptyState.hidden = false;
                if (readyState) readyState.hidden = true;
                if (body) delete body.dataset.hasSelection;
                if (preview) preview.hidden = true;
            }
        }

        function openDiakrivosiModal(triggerVariantId) {
            if (!diakrivosiModalOverlay || !diakrivosiModalList) return;
            activeDiakrivosiVariantId = triggerVariantId;

            // Get product data from the JSON script tag in the cell
            const cell = wrapper.querySelector('.diakrivosi-cell[data-variant-id="' + triggerVariantId + '"]');
            if (!cell) return;

            const dataScript = cell.querySelector('.diakrivoseis-data');
            if (!dataScript) return;

            let products;
            try {
                products = JSON.parse(dataScript.textContent);
            } catch(e) {
                console.error('Failed to parse diakrivoseis data:', e);
                return;
            }

            // Populate the context bar with the variant SKU + option
            // labels from the table row, so the user can see exactly
            // which instrument they're picking a certificate for.
            const triggerRow = wrapper.querySelector('tr[data-variant-id="' + triggerVariantId + '"]');
            const drawer = document.getElementById('diakrivosi-drawer');
            const ctxBar = drawer && drawer.querySelector('[data-diakrivosi-context]');
            const ctxSku = drawer && drawer.querySelector('[data-diakrivosi-context-sku]');
            const ctxOpts = drawer && drawer.querySelector('[data-diakrivosi-context-options]');
            const ctxThumb = drawer && drawer.querySelector('[data-diakrivosi-context-thumb]');
            const sniffedSku = triggerRow && triggerRow.querySelector('.ai-variants-table__sku');
            const sniffedOptions = triggerRow ? Array.from(triggerRow.querySelectorAll('.ai-variants-table__option')) : [];
            const skuText = sniffedSku ? sniffedSku.textContent.trim() : '';
            const thumbSrc = cell.dataset.variantThumb || '';
            if (ctxBar) {
                if (skuText || sniffedOptions.length) {
                    ctxBar.hidden = false;
                    if (ctxSku) ctxSku.textContent = skuText || '';
                    if (ctxOpts) {
                        // Render each option label as its own chip — easier to
                        // parse than the old middot-joined run-on string.
                        const chips = sniffedOptions
                            .map(function(o) { return o.textContent.trim().replace(/\s+/g, ' '); })
                            .filter(Boolean)
                            .map(function(t) {
                                const span = document.createElement('span');
                                span.className = 'diakrivosi-drawer__context-chip';
                                span.textContent = t;
                                return span;
                            });
                        ctxOpts.replaceChildren.apply(ctxOpts, chips);
                    }
                    if (ctxThumb) {
                        // Wipe any prior <img> then either drop the variant
                        // image in or leave the inline SVG fallback visible.
                        const prevImg = ctxThumb.querySelector('img');
                        if (prevImg) prevImg.remove();
                        if (thumbSrc) {
                            const img = document.createElement('img');
                            img.src = thumbSrc;
                            img.alt = '';
                            img.loading = 'lazy';
                            ctxThumb.prepend(img);
                            ctxThumb.classList.add('has-image');
                        } else {
                            ctxThumb.classList.remove('has-image');
                        }
                    }
                } else {
                    ctxBar.hidden = true;
                }
            }
            // Mirror the SKU into the CTA button's <strong> so the
            // user sees "Add to cart for MIT-500-196-30" — leaves no
            // doubt about which variant the calibration is paired with.
            const ctaSku = drawer && drawer.querySelector('[data-confirm-sku]');
            if (ctaSku) ctaSku.textContent = skuText || '';

            const currentSelection = diakrivosiSelections.get(triggerVariantId);
            const i18nAvailable = AIVT_CONFIG.i18n.availablePlural;
            const i18nOnOrder = AIVT_CONFIG.i18n.onOrder;
            const i18nExpected = AIVT_CONFIG.i18n.expected;
            const i18nAskUs = AIVT_CONFIG.i18n.askUs;
            const i18nViewProduct = AIVT_CONFIG.i18n.viewProduct;
            const i18nCertificate = AIVT_CONFIG.i18n.certificate;
            const i18nDelivery = AIVT_CONFIG.i18n.delivery;
            const i18nPrice = AIVT_CONFIG.i18n.price;

            // Sort by price: cheapest first
            products.sort(function(a, b) { return a.price - b.price; });

            // Build modal items
            diakrivosiModalList.innerHTML = products.map(function(p) {
                const isSelected = currentSelection && String(currentSelection.variantId) === String(p.variantId);
                let stockHtml = '';
                if (p.available && p.inventoryQuantity > 0) {
                    stockHtml = '<span class="diakrivosi-stock-in">' + p.inventoryQuantity + ' ' + i18nAvailable + '</span>';
                } else if (p.available) {
                    stockHtml = '<span class="diakrivosi-stock-order">' + i18nOnOrder + '</span>';
                } else {
                    stockHtml = '<span class="diakrivosi-stock-out">' + i18nExpected + '</span>';
                }

                let imageHtml = '';
                if (p.image) {
                    imageHtml = '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">';
                } else {
                    imageHtml = '<div class="diakrivosi-modal__item-no-image"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
                }

                let priceText = p.price === 0 ? i18nAskUs : p.priceFormatted;

                const eyebrowParts = [];
                if (p.vendor) eyebrowParts.push(p.vendor);
                else eyebrowParts.push(i18nCertificate);
                if (p.code) eyebrowParts.push(p.code);
                const eyebrowText = eyebrowParts.join(' · ');

                // Some translated titles lead with the code («CAU-17025-MAIN - Calibration
                // Certificate» on /en) and the SKU line repeats it: show the code once.
                let cardTitle = p.title || '';
                let showSku = !!p.sku;
                if (p.sku && cardTitle.indexOf(p.sku) === 0) {
                    const rest = cardTitle.slice(p.sku.length).replace(/^\s*[-–—·:|]\s*/, '').trim();
                    if (rest) cardTitle = rest;
                    else showSku = false;
                }

                const timeHtml = p.time
                    ? '<div class="diakrivosi-modal__item-time"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/></svg><span>' + p.time + '</span></div>'
                    : '<div class="diakrivosi-modal__item-time" style="color:#a8a8a0;font-weight:600;">—</div>';

                const linkHtml = p.url
                    ? '<a href="' + p.url + '" target="_blank" class="diakrivosi-modal__item-link" onclick="event.stopPropagation()">' + i18nViewProduct + ' <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>'
                    : '<span></span>';

                // WORK-379: product metafield custom.calibration_scope_note (translated on /en).
                const noteHtml = p.scopeNote
                    ? '<div class="diakrivosi-modal__item-note"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16.5"/><line x1="12" y1="7.6" x2="12" y2="7.7"/></svg><span>' + String(p.scopeNote).replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span></div>'
                    : '';

                // WORK-264: a 0-price certificate is quoted, never co-added at 0 €: shown with
                // «Ρωτήστε μας», not selectable.
                const isQuote = Number(p.price) === 0;
                return '<div class="diakrivosi-modal__item' + (isSelected && !isQuote ? ' is-selected' : '') + (isQuote ? ' is-quote' : '') + '" data-diakrivosi-item data-variant-id="' + p.variantId + '"' + (isQuote ? ' aria-disabled="true"' : '') + '>' +
                    '<input type="radio" name="diakrivosi-selection" class="diakrivosi-modal__radio" value="' + p.variantId + '"' + (isQuote ? ' disabled' : '') +
                    ' data-product-title="' + (p.title || '').replace(/"/g, '&quot;') + '"' +
                    ' data-product-price="' + (p.priceFormatted || '').replace(/"/g, '&quot;') + '"' +
                    ' data-product-price-raw="' + p.price + '"' +
                    ' data-product-image="' + (p.image || '') + '"' +
                    ' data-product-available="' + p.available + '"' +
                    ' data-product-sku="' + (p.sku || '').replace(/"/g, '&quot;') + '"' +
                    ' data-product-url="' + (p.url || '') + '"' +
                    ' data-product-handle="' + (p.handle || '') + '"' +
                    ' data-product-vendor="' + (p.vendor || '').replace(/"/g, '&quot;') + '"' +
                    ' data-product-code="' + (p.code || '').replace(/"/g, '&quot;') + '"' +
                    ' data-product-compare-price="' + (p.compareAtPrice || '') + '"' +
                    ' data-product-time="' + (p.time || '') + '"' +
                    (isSelected ? ' checked' : '') + '>' +
                    '<div class="diakrivosi-modal__item-head">' +
                        '<div class="diakrivosi-modal__item-check" aria-hidden="true">' +
                            '<span class="diakrivosi-modal__item-check-circle">' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
                            '</span>' +
                            '<span class="diakrivosi-modal__item-check-label">ΕΠΙΛΟΓΗ</span>' +
                        '</div>' +
                        '<div class="diakrivosi-modal__item-image">' + imageHtml + '</div>' +
                        '<div class="diakrivosi-modal__item-info">' +
                            '<div class="diakrivosi-modal__item-eyebrow">' + eyebrowText + '</div>' +
                            '<div class="diakrivosi-modal__item-title">' + cardTitle + '</div>' +
                            (showSku ? '<div class="diakrivosi-modal__item-sku">' + p.sku + '</div>' : '') +
                        '</div>' +
                    '</div>' +
                    '<div class="diakrivosi-modal__item-deck">' +
                        '<div class="diakrivosi-modal__item-deck-cell">' +
                            '<span class="diakrivosi-modal__item-deck-label">' + i18nDelivery + '</span>' +
                            timeHtml +
                        '</div>' +
                        '<div class="diakrivosi-modal__item-deck-cell">' +
                            '<span class="diakrivosi-modal__item-deck-label">' + i18nPrice + '</span>' +
                            '<div class="diakrivosi-modal__item-price">' + priceText + '</div>' +
                        '</div>' +
                    '</div>' +
                    noteHtml +
                    '<div class="diakrivosi-modal__item-meta">' +
                        '<span class="diakrivosi-modal__item-stock">' + stockHtml + '</span>' +
                        linkHtml +
                    '</div>' +
                '</div>';
            }).join('');

            updateDiakrivosiFooterPreview();
            if (window.SiteDrawer) {
                window.SiteDrawer.open('diakrivosi-drawer');
            }
        }

        function closeDiakrivosiModal() {
            if (window.SiteDrawer) {
                window.SiteDrawer.close('diakrivosi-drawer');
            }
            activeDiakrivosiVariantId = null;
        }

        function updateDiakrivosiCell(variantId) {
            const cell = wrapper.querySelector('.diakrivosi-cell[data-variant-id="' + variantId + '"]');
            if (!cell) return;

            const row = cell.closest('tr');
            const selectBtn = cell.querySelector('.diakrivosi-select-btn');
            const selectedInfo = cell.querySelector('[data-diakrivosi-selected-info]');
            const selection = diakrivosiSelections.get(variantId);

            if (selection) {
                if (selectBtn) selectBtn.style.display = 'none';
                if (selectedInfo) {
                    selectedInfo.style.display = 'flex';
                    // Chip label is the generic "Διακρίβωση" (PDP revamp / Claude
                    // Design) — the full calibration product name is visible in
                    // the drawer; the chip stays compact so the row doesn't grow.
                    selectedInfo.querySelector('.diakrivosi-selected-title').textContent =
                        AIVT_CONFIG.i18n.calibrationShort || selection.title;
                    const priceEl = selectedInfo.querySelector('.diakrivosi-selected-price');
                    if (priceEl) priceEl.textContent = selection.price ? '+ ' + selection.price : '';
                    // Anchor the chip to THIS variant by echoing the row's
                    // SKU into the eyebrow → "ΓΙΑ 1108-150". Removes any
                    // ambiguity about which row the attached calibration
                    // belongs to, even when the row scrolls past the column
                    // header / when there are several selections in view.
                    const eyebrow = selectedInfo.querySelector('[data-diakrivosi-selected-eyebrow]');
                    const sku = row?.querySelector('.ai-variants-table__sku')?.textContent.trim() || '';
                    if (eyebrow) {
                        if (sku) {
                            eyebrow.innerHTML = 'Για <strong>' + sku.replace(/[<>&]/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;'}[c])) + '</strong>';
                        } else {
                            eyebrow.textContent = AIVT_CONFIG.i18n.attachedEyebrow;
                        }
                    }
                }
                if (row) row.classList.add('row-has-diakrivosi');
            } else {
                if (selectBtn) selectBtn.style.display = '';
                if (selectedInfo) selectedInfo.style.display = 'none';
                if (row) row.classList.remove('row-has-diakrivosi');
            }
        }

        // Selection click on modal items - toggle behavior
        if (diakrivosiModalList) {
            diakrivosiModalList.addEventListener('click', function(e) {
                const item = e.target.closest('[data-diakrivosi-item]');
                if (!item || item.classList.contains('is-quote')) return;   // WORK-264: 0-price, quote only
                e.preventDefault();

                const radio = item.querySelector('input[type="radio"]');
                if (!radio) return;

                const wasSelected = item.classList.contains('is-selected');

                diakrivosiModalList.querySelectorAll('[data-diakrivosi-item]').forEach(function(i) {
                    i.classList.remove('is-selected');
                    i.querySelector('input[type="radio"]').checked = false;
                });

                if (!wasSelected) {
                    radio.checked = true;
                    item.classList.add('is-selected');
                }
                updateDiakrivosiFooterPreview();
            });
        }

        // Confirm button: just attaches the picked calibration to the row
        // and closes the drawer. The user must then click the row's + to
        // actually add to cart — the existing form-submit handler picks the
        // attached calibration up via diakrivosiSelections and co-adds it.
        // Was previously auto-submitting the form here, but that made the
        // selected-state in the row ambiguous (user couldn't tell whether
        // the variant had silently entered the cart or not).
        if (diakrivosiModalConfirm) {
            diakrivosiModalConfirm.addEventListener('click', function() {
                if (!activeDiakrivosiVariantId) return;

                const checked = diakrivosiModalList.querySelector('input[type="radio"]:checked');
                if (checked) {
                    diakrivosiSelections.set(activeDiakrivosiVariantId, {
                        variantId: checked.value,
                        title: checked.dataset.productTitle,
                        price: checked.dataset.productPrice,
                        priceRaw: checked.dataset.productPriceRaw,
                        image: checked.dataset.productImage,
                        available: checked.dataset.productAvailable === 'true',
                        sku: checked.dataset.productSku,
                        url: checked.dataset.productUrl,
                        handle: checked.dataset.productHandle,
                        vendor: checked.dataset.productVendor,
                        code: checked.dataset.productCode,
                        comparePrice: checked.dataset.productComparePrice,
                        time: checked.dataset.productTime
                    });
                } else {
                    diakrivosiSelections.delete(activeDiakrivosiVariantId);
                }

                const justConfirmedVariantId = activeDiakrivosiVariantId;
                updateDiakrivosiCell(justConfirmedVariantId);
                closeDiakrivosiModal();

                // If the parent tape is already in the cart, the + button
                // is now an in-cart qty-bump (it bypasses the form-submit
                // co-add path). So commit the cert immediately ourselves.
                // Helper returns false if parent isn't in cart yet — in
                // that case the user adds via + as usual.
                const sel = diakrivosiSelections.get(justConfirmedVariantId);
                if (sel) {
                    coAddCompanionIfParentInCart(justConfirmedVariantId, 'diakrivosi', sel);
                }

                // Brief pulse on the row's + button so the eye is drawn to
                // the next required action (it's the only way the cart
                // actually gets the calibration now).
                const ctrl = wrapper.querySelector('[data-cart-control][data-variant-id="' + justConfirmedVariantId + '"]');
                if (ctrl) {
                    ctrl.classList.remove('vt-stepper--pulse');
                    // force reflow so re-adding the class re-runs the animation
                    void ctrl.offsetWidth;
                    ctrl.classList.add('vt-stepper--pulse');
                }
            });
        }

        // Open modal from table cell buttons (event delegation)
        wrapper.addEventListener('click', function(e) {
            // Handle remove button
            const removeBtn = e.target.closest('[data-diakrivosi-remove]');
            if (removeBtn) {
                e.preventDefault();
                e.stopPropagation();
                const variantId = removeBtn.dataset.variantId;
                diakrivosiSelections.delete(variantId);
                updateDiakrivosiCell(variantId);
                return;
            }

            // Handle select/change button
            const trigger = e.target.closest('[data-diakrivosi-trigger]');
            if (!trigger) return;
            e.preventDefault();
            const variantId = trigger.dataset.variantId;
            openDiakrivosiModal(variantId);
        });

        // Close modal
        if (diakrivosiModalClose) {
            diakrivosiModalClose.addEventListener('click', closeDiakrivosiModal);
        }
        if (diakrivosiModalOverlay) {
            diakrivosiModalOverlay.addEventListener('click', function(e) {
                if (e.target === diakrivosiModalOverlay) closeDiakrivosiModal();
            });
        }
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && diakrivosiModalOverlay?.classList.contains('is-open')) {
                closeDiakrivosiModal();
            }
        });
      }

      // Calibration Modal Logic
      const modalOverlay = document.getElementById('calibration-modal-overlay');
      const modalContent = document.getElementById('calibration-modal-content');
      const closeBtn = modalOverlay?.querySelector('.calibration-modal__close');

      function openCalibrationModal(data) {
          if (!modalOverlay || !modalContent) return;

          // Build modal content
          let imageHtml = '';
          if (data.image) {
              imageHtml = `<img class="calibration-modal__image" src="${data.image}" alt="${data.title}" loading="lazy">`;
          }

          let comparePriceHtml = '';
          if (data.comparePrice) {
              comparePriceHtml = `<span class="calibration-modal__compare-price">${data.comparePrice}</span>`;
          }

          let timeHtml = '';
          if (data.time) {
              timeHtml = `
                  <div class="calibration-modal__time">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"/></svg>
                      ${data.time}
                  </div>
              `;
          }

          let vendorHtml = '';
          if (data.vendor) {
              vendorHtml = `<div class="calibration-modal__vendor">${data.vendor}</div>`;
          }

          let codeHtml = '';
          if (data.code) {
              codeHtml = `<div class="calibration-modal__code" style="font-size: 16px; color: #333; margin-top: 8px; margin-bottom: 8px; font-weight: 600;">${data.code}</div>`;
          }

          modalContent.innerHTML = `
              ${imageHtml}
              <div class="calibration-modal__content">
                  <h3 class="calibration-modal__title" id="calibration-modal-title">${data.title}</h3>
                  ${codeHtml}
                  ${vendorHtml}
                  <div class="calibration-modal__price-row">
                      <span class="calibration-modal__price">${data.price}</span>
                      ${comparePriceHtml}
                  </div>
                  ${timeHtml}
                  <a href="${data.url}" class="calibration-modal__link">
                      Δείτε το προϊόν
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                  </a>
              </div>
          `;

          modalOverlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';

          // Focus trap
          closeBtn?.focus();
      }

      function closeCalibrationModal() {
          if (!modalOverlay) return;
          modalOverlay.classList.remove('is-open');
          document.body.style.overflow = '';
      }

      // Event delegation for calibration info triggers (works with dynamically loaded rows)
      wrapper.addEventListener('click', function(e) {
          const trigger = e.target.closest('.calibration-info-trigger');
          if (trigger) {
              e.preventDefault();
              e.stopPropagation();

              const data = {
                  handle: trigger.dataset.calibrationProductHandle,
                  title: trigger.dataset.calibrationProductTitle,
                  vendor: trigger.dataset.calibrationProductVendor,
                  code: trigger.dataset.calibrationProductCode,
                  price: trigger.dataset.calibrationProductPrice,
                  comparePrice: trigger.dataset.calibrationProductComparePrice,
                  image: trigger.dataset.calibrationProductImage,
                  url: trigger.dataset.calibrationProductUrl,
                  time: trigger.dataset.calibrationTime
              };

              openCalibrationModal(data);
          }
      });

      // Close modal events
      if (closeBtn) {
          closeBtn.addEventListener('click', closeCalibrationModal);
      }

      if (modalOverlay) {
          modalOverlay.addEventListener('click', function(e) {
              if (e.target === modalOverlay) {
                  closeCalibrationModal();
              }
          });
      }

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && modalOverlay?.classList.contains('is-open')) {
              closeCalibrationModal();
          }
      });

      // ============================================
      // ΒΑΡΙΔΙΟ (Varidio / Weight) Selection Logic
      // ============================================
      const hasBaridia = AIVT_CONFIG.hasBaridia;

      if (hasBaridia) {
        const varidioDrawer = document.getElementById('varidio-drawer');
        const varidioModalList = document.getElementById('varidio-modal-list');
        const varidioModalConfirm = document.getElementById('varidio-modal-confirm');
        const varidioRequiredModal = document.getElementById('varidio-required-modal');

        // Track selected varidio PER variant row (Map: variantId -> selection data)
        const varidioSelections = new Map();
        let activeVariantId = null; // which variant row triggered the drawer

        // Updates the sticky footer band: shows the eyebrow/title/price
        // ticker once a card is picked, and flips the CTA between the
        // empty hint ("Επιλέξτε βαρίδιο") and the ready state
        // ("Επιβεβαίωση για <SKU>"). Mirrors the diakrivosi pattern.
        function updateVaridioFooterPreview() {
            if (!varidioDrawer) return;
            const preview = varidioDrawer.querySelector('[data-varidio-preview]');
            const empty = varidioDrawer.querySelector('[data-varidio-confirm-empty]');
            const ready = varidioDrawer.querySelector('[data-varidio-confirm-ready]');
            const body = varidioDrawer.querySelector('.varidio-drawer__body');
            const checked = varidioModalList && varidioModalList.querySelector('input[type="radio"]:checked');

            if (checked) {
                if (varidioModalConfirm) varidioModalConfirm.disabled = false;
                if (empty) empty.hidden = true;
                if (ready) ready.hidden = false;
                if (body) body.dataset.hasSelection = 'true';
                if (preview) {
                    preview.hidden = false;
                    const titleEl = preview.querySelector('[data-varidio-preview-title]');
                    const priceEl = preview.querySelector('[data-varidio-preview-price]');
                    if (titleEl) titleEl.textContent = checked.dataset.productTitle || '';
                    if (priceEl) {
                        const raw = parseFloat(checked.dataset.productPriceRaw || '0');
                        priceEl.textContent = raw > 0 ? '+ ' + (checked.dataset.productPrice || '') : (checked.dataset.productPrice || '');
                    }
                }
            } else {
                if (varidioModalConfirm) varidioModalConfirm.disabled = true;
                if (empty) empty.hidden = false;
                if (ready) ready.hidden = true;
                if (body) delete body.dataset.hasSelection;
                if (preview) preview.hidden = true;
            }
        }

        function openVaridioModal(triggerVariantId) {
            if (!varidioDrawer || !varidioModalList) return;
            activeVariantId = triggerVariantId;

            // Populate the context bar with the tape row's SKU + option
            // labels + image — so the user can see exactly which tape
            // they're picking a baridio for. Mirrors the diakrivosi
            // context-bar pattern.
            const triggerRow = wrapper.querySelector('tr[data-variant-id="' + triggerVariantId + '"]');
            const cell = wrapper.querySelector('.varidio-cell[data-variant-id="' + triggerVariantId + '"]');
            const ctxBar = varidioDrawer.querySelector('[data-varidio-context]');
            const ctxSku = varidioDrawer.querySelector('[data-varidio-context-sku]');
            const ctxOpts = varidioDrawer.querySelector('[data-varidio-context-options]');
            const ctxThumb = varidioDrawer.querySelector('[data-varidio-context-thumb]');
            const sniffedSku = triggerRow && triggerRow.querySelector('.ai-variants-table__sku');
            const sniffedOptions = triggerRow ? Array.from(triggerRow.querySelectorAll('.ai-variants-table__option')) : [];
            const skuText = sniffedSku ? sniffedSku.textContent.trim() : '';
            // Tape product has a single featured image — use it directly.
            // No per-variant thumbnail data attribute exists on varidio cells.
            const thumbSrc = AIVT_CONFIG.product.image200;
            if (ctxBar) {
                if (skuText || sniffedOptions.length) {
                    ctxBar.hidden = false;
                    if (ctxSku) ctxSku.textContent = skuText || '';
                    if (ctxOpts) {
                        const chips = sniffedOptions
                            .map(function(o) { return o.textContent.trim().replace(/\s+/g, ' '); })
                            .filter(Boolean)
                            .map(function(t) {
                                const span = document.createElement('span');
                                span.className = 'varidio-drawer__context-chip';
                                span.textContent = t;
                                return span;
                            });
                        ctxOpts.replaceChildren.apply(ctxOpts, chips);
                    }
                    if (ctxThumb) {
                        const prevImg = ctxThumb.querySelector('img');
                        if (prevImg) prevImg.remove();
                        if (thumbSrc) {
                            const img = document.createElement('img');
                            img.src = thumbSrc;
                            img.alt = '';
                            img.loading = 'lazy';
                            ctxThumb.prepend(img);
                            ctxThumb.classList.add('has-image');
                        } else {
                            ctxThumb.classList.remove('has-image');
                        }
                    }
                } else {
                    ctxBar.hidden = true;
                }
            }
            // Mirror the SKU into the confirm CTA's <strong>.
            const ctaSku = varidioDrawer.querySelector('[data-varidio-confirm-sku]');
            if (ctaSku) ctaSku.textContent = skuText || '';

            // Restore selection state in drawer for THIS variant's choice
            const currentSelection = varidioSelections.get(triggerVariantId);
            const items = varidioModalList.querySelectorAll('[data-varidio-item]');
            items.forEach(item => {
                const radio = item.querySelector('input[type="radio"]');
                if (currentSelection && String(radio.value) === String(currentSelection.variantId)) {
                    radio.checked = true;
                    item.classList.add('is-selected');
                } else {
                    radio.checked = false;
                    item.classList.remove('is-selected');
                }
            });

            updateVaridioFooterPreview();

            if (window.SiteDrawer) {
                window.SiteDrawer.open('varidio-drawer');
            }
        }

        function closeVaridioModal() {
            if (window.SiteDrawer) {
                window.SiteDrawer.close('varidio-drawer');
            }
            activeVariantId = null;
        }

        function updateVaridioCell(variantId) {
            // Update ONLY the specific variant row's varidio cell
            const cell = wrapper.querySelector('.varidio-cell[data-variant-id="' + variantId + '"]');
            if (!cell) return;

            const selectBtn = cell.querySelector('.varidio-select-btn');
            const selectedInfo = cell.querySelector('[data-varidio-selected-info]');
            const selection = varidioSelections.get(variantId);

            if (selection) {
                if (selectBtn) selectBtn.style.display = 'none';
                if (selectedInfo) {
                    selectedInfo.style.display = 'flex';
                    // Title
                    selectedInfo.querySelector('.varidio-selected-title').textContent = selection.title;
                    // SKU
                    const skuEl = selectedInfo.querySelector('.varidio-selected-sku');
                    if (skuEl) skuEl.textContent = selection.sku || '';
                    // Price
                    const priceEl = selectedInfo.querySelector('.varidio-selected-price');
                    if (priceEl) priceEl.textContent = selection.price ? '+ ' + selection.price : '';
                    // Thumbnail
                    const thumbEl = selectedInfo.querySelector('.varidio-selected-thumb');
                    if (thumbEl) {
                        if (selection.image) {
                            thumbEl.innerHTML = '<img src="' + selection.image + '" alt="' + (selection.title || '') + '">';
                        } else {
                            thumbEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" style="margin:12px auto;display:block;"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
                        }
                    }
                }
            } else {
                if (selectBtn) selectBtn.style.display = 'inline-flex';
                if (selectedInfo) selectedInfo.style.display = 'none';
            }
        }

        // Selection click on drawer items - toggle behavior (click again to deselect)
        if (varidioModalList) {
            varidioModalList.addEventListener('click', function(e) {
                const item = e.target.closest('[data-varidio-item]');
                if (!item || item.classList.contains('is-quote')) return;   // WORK-264: 0-price, quote only
                e.preventDefault();

                const radio = item.querySelector('input[type="radio"]');
                if (!radio) return;

                const wasSelected = item.classList.contains('is-selected');

                // Deselect all first
                varidioModalList.querySelectorAll('[data-varidio-item]').forEach(i => {
                    i.classList.remove('is-selected');
                    i.querySelector('input[type="radio"]').checked = false;
                });

                if (!wasSelected) {
                    radio.checked = true;
                    item.classList.add('is-selected');
                }
                // updateVaridioFooterPreview() handles confirm-btn enable
                // state, eyebrow/title/price ticker, and hides the hint.
                updateVaridioFooterPreview();
            });
        }

        // Confirm button
        if (varidioModalConfirm) {
            varidioModalConfirm.addEventListener('click', function() {
                if (!activeVariantId) return;

                const checked = varidioModalList.querySelector('input[type="radio"]:checked');
                if (checked) {
                    // Save selection for this specific variant
                    varidioSelections.set(activeVariantId, {
                        variantId: checked.value,
                        title: checked.dataset.productTitle,
                        price: checked.dataset.productPrice,
                        priceRaw: checked.dataset.productPriceRaw,
                        image: checked.dataset.productImage,
                        available: checked.dataset.productAvailable === 'true',
                        sku: checked.dataset.productSku,
                        url: checked.dataset.productUrl
                    });
                } else {
                    // Nothing checked -> remove selection for this variant
                    varidioSelections.delete(activeVariantId);
                }

                const justConfirmedVariantId = activeVariantId;
                updateVaridioCell(justConfirmedVariantId);
                closeVaridioModal();

                // Mirror the diakrivosi behaviour: if the parent tape is
                // already in the cart, commit the baridio immediately —
                // the + button is now an in-cart qty-bump and won't run
                // the form-submit co-add path.
                const sel = varidioSelections.get(justConfirmedVariantId);
                if (sel) {
                    coAddCompanionIfParentInCart(justConfirmedVariantId, 'varidio', sel);
                }
            });
        }

        // Open modal from table cell buttons (event delegation for dynamic rows)
        wrapper.addEventListener('click', function(e) {
            // Handle remove button (X) - instant remove, no modal
            const removeBtn = e.target.closest('[data-varidio-remove]');
            if (removeBtn) {
                e.preventDefault();
                e.stopPropagation();
                const variantId = removeBtn.dataset.variantId;
                varidioSelections.delete(variantId);
                updateVaridioCell(variantId);
                return;
            }

            // Handle change/select button - opens modal
            const trigger = e.target.closest('[data-varidio-trigger]');
            if (!trigger) return;
            e.preventDefault();
            const variantId = trigger.dataset.variantId;
            openVaridioModal(variantId);
        });

        // Drawer overlay click, close button (data-drawer-close), and
        // Escape are all handled by assets/site-drawer.js — no need to
        // wire any of that here. We do still need to clear
        // activeVariantId when the drawer closes; observe the .is-open
        // class flip so confirm-button clicks after a manual close don't
        // mutate stale state.
        if (varidioDrawer) {
            const obs = new MutationObserver(function() {
                if (!varidioDrawer.classList.contains('is-open')) {
                    activeVariantId = null;
                }
            });
            obs.observe(varidioDrawer, { attributes: true, attributeFilter: ['class'] });
        }

        // Varidio Required Modal functions
        function showVaridioRequiredModal() {
            if (!varidioRequiredModal) return;
            varidioRequiredModal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        }
        function hideVaridioRequiredModal() {
            if (!varidioRequiredModal) return;
            varidioRequiredModal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }

        // Close required modal events
        varidioRequiredModal?.addEventListener('click', function(e) {
            if (e.target.hasAttribute('data-varidio-required-close') || e.target.closest('[data-varidio-required-close]')) {
                hideVaridioRequiredModal();
            }
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && varidioRequiredModal?.getAttribute('aria-hidden') === 'false') {
                hideVaridioRequiredModal();
            }
        });

        // ============================================
        // INTERCEPT ADD-TO-CART: Require varidio selection
        // ============================================
        wrapper.addEventListener('submit', function(e) {
            if (!e.target.classList.contains('ai-variants-table__form')) return;

            const form = e.target;
            const row = form.closest('tr');
            const rowVariantId = row?.dataset.variantId;
            const selection = rowVariantId ? varidioSelections.get(rowVariantId) : null;

            // Check if varidio is required but not selected for THIS variant
            if (!selection) {
                e.preventDefault();
                e.stopImmediatePropagation();
                // The stepper click handler optimistically added `is-loading` to
                // the row's cart control before firing form.requestSubmit().
                // Because we abort here, the bubble-phase handler that normally
                // clears `is-loading` (success/error paths) never runs — leaving
                // the + button stuck with pointer-events:none. Strip it so the
                // user can click + again after dismissing the required modal.
                const ctrl = form.querySelector('[data-cart-control]');
                if (ctrl) ctrl.classList.remove('is-loading');
                showVaridioRequiredModal();
                return false;
            }

            // Varidio is selected for this variant - inject properties
            form.querySelectorAll('.varidio-cart-input').forEach(el => el.remove());

            const varidioInput = document.createElement('input');
            varidioInput.type = 'hidden';
            varidioInput.name = 'properties[Βαρίδιο]';
            varidioInput.value = selection.title;
            varidioInput.className = 'varidio-cart-input';
            form.appendChild(varidioInput);

            form.dataset.varidioVariantId = selection.variantId;

        }, true); // Capturing phase to fire BEFORE the existing handler
      }
    })();

    // Custom Wishlist — uses window.Wishlist from wishlist.js
    (function() {
      var wrapper = document.querySelector('.ai-variants-table');
      if (!wrapper) return;

      var productTitle = AIVT_CONFIG.product.title;
      var productImage = AIVT_CONFIG.product.image160;
      var productUrl = AIVT_CONFIG.product.url;

      var i18n = {
        removed: AIVT_CONFIG.i18n.wishlistRemoved
      };


      // Toast removed alongside the slide-down notification — heart
      // icon toggling state is the feedback for "removed", drawer
      // opening is the feedback for "added".
      function showToast() { /* no-op */ }

      // Restore visual state for all buttons in a container
      function restoreState(container) {
        if (!window.Wishlist) return;
        var btns = container.querySelectorAll('.ai-variants-table__wishlist-btn');
        btns.forEach(function(btn) {
          var vid = btn.dataset.variantId;
          if (window.Wishlist.has(vid)) {
            btn.classList.add('wishlisted');
            btn.setAttribute('aria-label', 'Remove from Wishlist');
          } else {
            btn.classList.remove('wishlisted');
            btn.setAttribute('aria-label', 'Add to Wishlist');
          }
        });
      }

      // Click handler via event delegation
      wrapper.addEventListener('click', function(e) {
        var btn = e.target.closest('.ai-variants-table__wishlist-btn');
        if (!btn || !window.Wishlist) return;
        e.preventDefault();
        e.stopPropagation();

        var vid = btn.dataset.variantId;
        var handle = btn.dataset.productHandle;
        var added = window.Wishlist.toggle(vid, handle);

        if (added) {
          btn.classList.add('wishlisted');
          btn.setAttribute('aria-label', 'Remove from Wishlist');
          // Feedback is now via the wishlist drawer (wishlist:changed
          // listener in snippets/wishlist-drawer.liquid auto-opens it on
          // 'add'); the old slide-down top notification has been removed.
        } else {
          btn.classList.remove('wishlisted');
          btn.setAttribute('aria-label', 'Add to Wishlist');
          showToast(i18n.removed);
        }
      });

      // Initial restore
      restoreState(wrapper);

      // Restore when new rows are loaded (load-more / auto-load)
      wrapper.addEventListener('wishlist:restore', function() {
        restoreState(wrapper);
      });

      // Sync UI when wishlist changes from another context (e.g. wishlist page removal)
      document.addEventListener('wishlist:changed', function() {
        restoreState(wrapper);
      });
    })();

    // EU stock — click-to-toggle popover. Fixed-positioned so it escapes
    // the table's overflow/stacking context (it would otherwise be clipped
    // by the scroll wrapper). One open popover at a time.
    // WORK-284: fixed is not enough for its dim (a 100vmax box-shadow): the table sits in
    // main#site-main (z-index 500), below the header (1120) and the side menu (1115), so those
    // stayed bright. While open, the popover lives in a holder under <body> above both; the
    // popover's rules match there through :is(.ai-variants-table, .vt-pop-host).
    (function() {
      var root = document.querySelector('.ai-variants-table');
      if (!root) return;
      var openPop = null, openBtn = null, home = null, homeNext = null;
      var host = document.createElement('div');
      host.className = 'vt-pop-host';
      document.body.appendChild(host);
      host.addEventListener('click', function(e) {
        if (e.target.closest('[data-eu-stock-close]')) { e.preventDefault(); close(); }
      });

      function place(btn, pop) {
        var gap = 8;
        var r = btn.getBoundingClientRect();
        var pw = pop.offsetWidth, ph = pop.offsetHeight;
        // right-align the popover to the button, clamped to the viewport
        var left = r.right - pw;
        if (left < 8) left = 8;
        if (left + pw > window.innerWidth - 8) left = window.innerWidth - 8 - pw;
        // prefer above the button; flip below if there's no room
        var top = r.top - ph - gap;
        pop.style.transformOrigin = 'top right';
        if (top < 8) {
          top = r.bottom + gap;
          pop.style.transformOrigin = 'bottom right';
        }
        pop.style.left = Math.round(left) + 'px';
        pop.style.top = Math.round(top) + 'px';
      }

      function close() {
        if (!openPop) return;
        var pop = openPop, back = home, next = homeNext;
        pop.classList.remove('is-open');
        pop.setAttribute('aria-hidden', 'true');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        openPop = null; openBtn = null; home = null; homeNext = null;
        // back into its row once the fade-out is done (unless it was reopened meanwhile)
        setTimeout(function() {
          if (openPop !== pop && back && pop.parentNode === host) back.insertBefore(pop, next && next.parentNode === back ? next : null);
        }, 200);
      }

      function open(btn, pop) {
        if (pop.parentNode !== host) {
          home = pop.parentNode; homeNext = pop.nextSibling;
          host.appendChild(pop);
        }
        pop._vtBtn = btn;
        place(btn, pop);
        pop.getBoundingClientRect(); // force reflow so the transition runs
        pop.classList.add('is-open');
        pop.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        openPop = pop; openBtn = btn;
      }

      root.addEventListener('click', function(e) {
        if (e.target.closest('[data-eu-stock-close]')) { e.preventDefault(); close(); return; }
        var btn = e.target.closest('[data-eu-stock-toggle]');
        if (btn) {
          e.preventDefault();
          // (while open, or fading out, the popover sits in the holder, not next to its button)
          var pop = btn.parentElement.querySelector('[data-eu-stock-pop]') ||
            Array.prototype.find.call(host.children, function(p) { return p._vtBtn === btn; });
          if (!pop) return;
          if (openBtn === btn) { close(); return; }
          close();
          open(btn, pop);
          return;
        }
        if (openPop && !e.target.closest('[data-eu-stock-pop]')) close();
      });

      document.addEventListener('click', function(e) {
        if (openPop && !e.target.closest('.ai-variants-table')) close();
      });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
      // keep it pinned to the button while open (or close if the button scrolls away)
      window.addEventListener('scroll', function() {
        if (openBtn && openPop) place(openBtn, openPop);
      }, true);
      window.addEventListener('resize', close);
    })();
